<template>
  <div class="main">
    <el-dialog :visible.sync="reachargevisible" width="600px" @close="chargeclose" :close-on-click-modal="false">
      <template slot="title">
        <div class="title">账户余额: ￥{{balance}}</div>
      </template>
      <div class="product_title">
        选择充值金额
        <span>
          （可用于平台保险、签证办理，通用于 官网小程序使用）
        </span>
      </div>
      <div class="product">
        <div class="product-item" v-for="(item,index) in rechargeProduct" :key="index"
          :class="orderId==item.Id?'active':''" @click="selectproduct(item)">
          ￥{{item.Money}}元
          <div class="product-name">{{item.Describe}}</div>
        </div>
        <div class="product-item" :class="orderId==null?'active':''" @click="selectproduct(null)">
          <el-input v-model="other" @click="selectproduct(null)" @blur="selectproduct(null)" placeholder="其他金额"
            type="number" style="border:none">
          </el-input>
          <div class="product-name">无赠送</div>
        </div>
      </div>

      <!-- <el-button type="primary" @click="pay">充值</el-button> -->
      <el-tabs tab-position="left" type="border-card" style="height: 190px;" @tab-click="handleClick">
        <el-tab-pane name="0">
          <template slot="label">
            <i><img src="../../assets/wechat.png" style="width: 20px;height: 20px;vertical-align: middle;" alt=""></i>

            微信支付
          </template>
          <div class="QrCode_box">
            <div class="qrcode_box">
              <div id="qrcode0" class="qrcode" ref="qrCodeUrl" v-loading="qrcodeLiading">

              </div>
              <div class="border_top_left"></div>
              <div class="border_top_right"></div>
              <div class="border_bottom_left"></div>
              <div class="border_bottom_right"></div>
            </div>


            <div class="payPrompt">
              应付金额：
              <span>
                ￥{{cashAmount}}
              </span>
              <p>{{ payPrompt }}</p>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="1">
          <template slot="label">
            <i><img src="../../assets/alipay.png" style="width: 20px;height: 20px;vertical-align: middle;" alt=""></i>
            支付宝支付
          </template>
          <div class="QrCode_box">

            <div class="qrcode_box">
              <div id="qrcode1" class="qrcode" ref="qrCodeUrl" v-loading="qrcodeLiading">

              </div>
              <div class="border_top_left"></div>
              <div class="border_top_right"></div>
              <div class="border_bottom_left"></div>
              <div class="border_bottom_right"></div>
            </div>
            <div class="payPrompt">
              应付金额：
              <span>
                ￥{{cashAmount}}
              </span>
              <p>{{ payPrompt }}</p>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>

      <!-- <el-dialog class="payDialog" width="320px" top="25vh" title="选择支付方式" :visible.sync="paytypeVisible"
        @closed="payClosed" append-to-body :close-on-click-modal="false" :modal-append-to-body="true">
        <div class="payBtn_box" v-if="payDisable == false">
          <div style="">
            <img src="../../assets/wechat.png" style="margin-right: 10px;width: 60px;height: 60px" alt=""
              @click="GetViasPay('W01', cashAmount)">
            <img src="../../assets/alipay.png" style="margin-right: 10px;width: 60px;height: 60px" alt=""
              @click="GetViasPay('A01', cashAmount)">
          </div>

          <br />
          <p>请选择您的支付方式</p>
        </div>

      </el-dialog> -->
    </el-dialog>
  </div>


</template>

<script>
  import QRCode from "qrcodejs2";
  export default {
    name: 'recharge',
    props: {
      dialogVisible: {
        type: Boolean,
      }
    },
    watch: {
      dialogVisible(newval) {
        this.reachargevisible = newval
        this.GetUserBalance();
        this.GetCrrechargeProducts();
      }
    },
    data() {
      return {
        reachargevisible: false,
        rechargeProduct: [],
        paytypeVisible: false,
        cashAmount: 0,
        orderId: '',
        balance: 0,
        other: "",
        payDisable: false,
        payPrompt: '',
        qrcodeLiading: false,
        trxid: '',
        isQuery: false,
        timer: null,
        qrcodeobj: null,
        exec: null,
        orderQuery: null,
        TabName: 0,
        payurl: '',
      }
    },
    created() {
      this.GetCrrechargeProducts();
      this.GetUserBalance();
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
        if (tab.index == 0) {
          this.GetViasPay('W01', this.cashAmount, 0);
          this.TabName = 0;
        } else {
          this.GetViasPay('A01', this.cashAmount, 1)
          this.TabName = 1
        }
      },

      GetCrrechargeProducts() {
        this.$api.GetCrrechargeProduct().then(res => {
          if (res.data.status == 200) {
            this.rechargeProduct = res.data.data
            if (this.rechargeProduct[0]) {
              this.selectproduct(this.rechargeProduct[0])
            }

          } else {
            this.$message.error(res.data.message)
          }
        })
      },

      selectproduct(item) {
        if (item) {
          this.orderId = item.Id;
          this.cashAmount = item.Money
        } else {
          this.orderId = null;
          this.cashAmount = this.other
        }
        if (this.cashAmount) {
          this.GetViasPay(this.TabName == 0 ? 'W01' : 'A01', this.cashAmount, this.TabName);
        }
        // this.payClosed()

      },
      GetUserBalance() {
        this.$api.GetUserBalance().then(res => {
          if (res.data.status == 200) {
            this.balance = res.data.data.Balance
          }
        })
      },
      chargeclose() {
        clearInterval(this.timer);
        this.$emit('chargeclose')
      },
      pay() {
        if (!this.orderId) {
          this.cashAmount = this.other
        }
        this.paytypeVisible = true
      },
      async GetViasPay(paytype, num, type) {
        this.exec = this.$api.GetRechargePay
        this.orderQuery = this.$api.RechargeQuery
        // 获取充值链接
        this.qrcodeLiading = true;
        this.payDisable = !this.payDisable;
        let params = {
          paytype: paytype,
          proId: this.orderId
        };
        params.money = num;
        if (paytype == "W01") {
          this.payPrompt = "请使用微信扫码支付";
        } else if (paytype == "A01") {
          this.payPrompt = "请使用支付宝扫码支付";
        }
        var res = await this.exec(params)
        let {
          status,
          data
        } = res.data;
        if (status == 200) {
          // this.$message.success('保存供应商付款成功');
          // this.$route.go(0);
          console.log(data)
          this.trxid = data.trxid;
          const dom = document.getElementById('qrcode' + type)
          if (dom) {
            dom.innerHTML = ''
          }
          this.payurl = data.payurl;
          this.qrcode(data.payurl, type);
          this.qrcodeLiading = false;
          this.isQuery = true;
          this.timer = setInterval(this.PayQuery, 3000);
        } else {
          this.$message.error('获取付款码失败');
        }
      },
      qrcode(link, num) {
        // 生成支付二维码
        let that = this;
        this.qrcodeobj = new QRCode("qrcode" + num, {
          width: 124,
          height: 124, // 高度
          text: link // 二维码内容
          // render: 'canvas' , // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
          // background: '#f0f', // 背景色
          // foreground: '#ff0' // 前景色
        });
        // debugger;
      },
      async PayQuery() {
        // 查询充值结果
        let params = {
          trxid: this.trxid
        };
        var res = await this.orderQuery(params)
        // console.log(res, '保存供应商付款',this.amountFormdata.extend);
        let {
          status,
          data
        } = res;
        if (status == 200) {
          console.log(data, "查询交易结果");
          if (data.message == "支付成功") {

            this.isQuery = false;
            clearInterval(this.timer);
            this.$emit('chargeclose')
            this.$emit("rechargeBack");
            // this.QueryAccount();
          }
        } else {
          this.$message.error("操作失败，" + data.message);
        }
      },
      payClosed() {
        // const dom = document.getElementById('qrcode' + this.TabName)
        // if (dom) dom.innerHTML = ''
        // this.$refs.qrCodeUrl.innerHTML = "";
        // 扫码支付弹框关闭时调用

        // qrcode.clear()

        if (this.isQuery) {
          this.PayQuery();
        }
      },

    }
  }

</script>

<style lang="less" scoped>
  .QrCode_box {
    display: flex;
    justify-content: space-around;
    align-items: center;

    .qrcode_box {
      position: relative;
      padding: 5px;
      width: 134px;
      height: 134px;
      display: flex;
      align-items: center;
      justify-content: space-around;

      .border_top_left {
        position: absolute;
        top: 0;
        left: 0;
        width: 10px;
        height: 10px;
        border-top: 2px solid #599FFF;
        border-left: 2px solid #599FFF;
      }

      .border_top_right {
        position: absolute;
        top: 0;
        right: 0;
        width: 10px;
        height: 10px;
        border-top: 2px solid #599FFF;
        border-right: 2px solid #599FFF;
      }

      .border_bottom_left {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 10px;
        height: 10px;
        border-bottom: 2px solid #599FFF;
        border-left: 2px solid #599FFF;
      }

      .border_bottom_right {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 10px;
        height: 10px;
        border-bottom: 2px solid #599FFF;
        border-right: 2px solid #599FFF;
      }

      .qrcode {
        width: 124px;
        height: 124px;
      }
    }




    .payPrompt {
      text-align: center;
      font-size: 12px;
      color: #999;
      margin-top: 10px;
      margin-bottom: 10px;

      span {
        display: block;
        color: #ff8439;
        font-size: 18px;
        font-weight: bold;
      }
    }
  }


  /deep/ .el-dialog__header {
    background-color: #2F333D;
    color: #F3F3F4;
  }

  /deep/.el-input__inner {
    border: none !important;
  }

  .title {
    height: 30px;
    line-height: 30px;
    text-align: left;
  }

  .product_title {
    text-align: left;
    font-size: 18px;
    font-weight: bold;
    color: #333;

    span {
      font-size: 12px;
      color: #999;
    }
  }

  .product {
    display: flex;
    flex-wrap: wrap;

    & .active {
      border: 1px solid #599FFF !important;

      .product-name {
        text-align: center;
        height: 30px;
        line-height: 30px;
        background-color: #599eff27;
        color: #599FFF;
        font-size: 12px;
        position: absolute;
        bottom: 0px;
        width: 100%;
      }
    }



    .product-item {
      width: 150px;
      height: 93px;
      border: 1px solid #ccc;
      font-size: 25px;
      position: relative;
      margin: 10px;
      line-height: 65px;
      border-radius: 5px;

    }

    .product-name {
      text-align: center;
      height: 30px;
      line-height: 30px;
      background-color: antiquewhite;
      font-size: 12px;
      position: absolute;
      bottom: 0px;
      width: 100%;
    }

  }

  /deep/ .el-tabs--left.el-tabs--border-card .el-tabs__item.is-left {
    border: 1px solid transparent;
    margin: -1px 0 -1px -1px;
    text-align: left;
  }

</style>



// WEBPACK FOOTER //
// src/components/Recharge/recharge.vue